import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import CandidateCardContext from '../../../CompoundComponents/CandidateCardWrapper/CandidateCardContext';
import styles from './CandidateCardShowDuplicate.module.scss';
import messages from '../CandidateCardMessages';

function CandidateCardShowDuplicate() {
  const { areDuplicateCandidatesVisible, setDuplicateCandidatesVisibility } = React.useContext(CandidateCardContext);

  const showDuplicateCardButtonText = areDuplicateCandidatesVisible ? (
    <FormattedMessage {...messages.hideDuplicatesLabel} />
  ) : (
    <FormattedMessage {...messages.seeDuplicatesLabel} />
  );

  const onClickShowDuplicatesButton = e => {
    e.stopPropagation();
    setDuplicateCandidatesVisibility(!areDuplicateCandidatesVisible);
  };

  const showDuplicatesCardButton = (
    <Button onClick={onClickShowDuplicatesButton} type="link" className={styles.showDuplicatesCardButton} size="small">
      {showDuplicateCardButtonText}
    </Button>
  );

  return <div className={styles.showDuplicatesCardWrapper}>{showDuplicatesCardButton}</div>;
}

export default CandidateCardShowDuplicate;
